import { modalBus } from './modalBus';
import { MODAL_IDS } from './modalIds';

function open(id, payload) {
    modalBus.emit(`open:${id}`, payload);
}

function close(id) {
    modalBus.emit(`close:${id}`);
}

export const openAcceptBill = (payload) => open(MODAL_IDS.acceptBill, payload);
export const closeAcceptBill = () => close(MODAL_IDS.acceptBill);

export const openPreApproveBill = (payload) => open(MODAL_IDS.preApproveBill, payload);
export const closePreApproveBill = () => close(MODAL_IDS.preApproveBill);

export const openRejectBill = (payload) => open(MODAL_IDS.rejectBill, payload);
export const closeRejectBill = () => close(MODAL_IDS.rejectBill);

export const openConfirmPayment = (payload) => open(MODAL_IDS.confirmPayment, payload);
export const closeConfirmPayment = () => close(MODAL_IDS.confirmPayment);

export const openObserveBill = (payload) => open(MODAL_IDS.observeBill, payload);
export const closeObserveBill = () => close(MODAL_IDS.observeBill);

export const openInvoiceDetail = (payload) => open(MODAL_IDS.invoiceDetail, payload);
export const closeInvoiceDetail = () => close(MODAL_IDS.invoiceDetail);

export const openObservationText = (payload) => open(MODAL_IDS.observationText, payload);
export const closeObservationText = () => close(MODAL_IDS.observationText);

export const openCorrectionBill = (payload) => open(MODAL_IDS.correctionBill, payload);
export const closeCorrectionBill = () => close(MODAL_IDS.correctionBill);

export const openGreView = (payload) => open(MODAL_IDS.greView, payload);
export const closeGreView = () => close(MODAL_IDS.greView);

export const openConfirmDeleteFile = (payload) => open(MODAL_IDS.confirmDeleteFile, payload);
export const closeConfirmDeleteFile = () => close(MODAL_IDS.confirmDeleteFile);

export const openConfirmDeleteInvoice = (payload) => open(MODAL_IDS.confirmDeleteInvoice, payload);
export const closeConfirmDeleteInvoice = () => close(MODAL_IDS.confirmDeleteInvoice);

export const openOcDetail = (payload) => open(MODAL_IDS.ocDetail, payload);
export const closeOcDetail = () => close(MODAL_IDS.ocDetail);

export const openNecDetail = (payload) => open(MODAL_IDS.necDetail, payload);
export const closeNecDetail = () => close(MODAL_IDS.necDetail);

export const openUploadDocument = (payload) => open(MODAL_IDS.uploadDocument, payload);
export const closeUploadDocument = () => close(MODAL_IDS.uploadDocument);

export const openSuccessUpload = () => open(MODAL_IDS.successUpload, undefined);
export const closeSuccessUpload = () => close(MODAL_IDS.successUpload);

export const openPurchaseOrderSettings = (payload) => open(MODAL_IDS.purchaseOrderSettings, payload);
export const closePurchaseOrderSettings = () => close(MODAL_IDS.purchaseOrderSettings);

export const openFinancingRequest = (payload) => open(MODAL_IDS.financingRequest, payload);
export const closeFinancingRequest = () => close(MODAL_IDS.financingRequest);

export const openFinancingAccept = (payload) => open(MODAL_IDS.financingAccept, payload);
export const closeFinancingAccept = () => close(MODAL_IDS.financingAccept);

export const openFinancingConfirm = (payload) => open(MODAL_IDS.financingConfirm, payload);
export const closeFinancingConfirm = () => close(MODAL_IDS.financingConfirm);

export const openBillAttachments = (payload) => open(MODAL_IDS.billAttachments, payload);
export const closeBillAttachments = () => close(MODAL_IDS.billAttachments);
